


















































































import { PinCodeMixin } from '@/mixins/pinCodeMixin'
import { apiRoutes } from '@/helpers/ApiRoutes'
import { Route } from 'vue-router'

export const TOKEN_PIN = 'tokenPin'
const HEADER_PIN_TOKEN = process.env.VUE_APP_HEADER_PIN_TOKEN

export default PinCodeMixin.extend({
  name: 'PinEnter',

  data: () => ({
    dialog: {
      show: false,
      title: 'Yettel',
      message: '',
      button: 'U redu'
    },
    prevRoute: {} as Route
  }),

  beforeRouteEnter (to, from, next) {
    next(vm => {
      // eslint-disable-next-line
      (vm as any).prevRoute = from
    })
  },

  computed: {
    prevRoutePath () { return this.prevRoute ? this.prevRoute.path : '/' }
  },

  mounted () {
    const input1 = this.$refs[this.pinKey + '0'] as Array<HTMLInputElement>
    input1[0].focus()
  },

  methods: {
    resetPinInit () {
      this.$router.push({ name: 'ResetPinInit', params: { appId: '2' } })
    },
    validatePin (): void {
      if (!this.buttonEnabled) {
        return
      }
      this.$axios.post(apiRoutes.validatePwaPin, this.postParams())
        .then(res => {
          if (res.data.data.success) {
            sessionStorage.setItem(TOKEN_PIN, res.data.data.tokenPin)
            if (sessionStorage.getItem(TOKEN_PIN)) {
              this.$axios.defaults.headers.common[HEADER_PIN_TOKEN] = sessionStorage.getItem(TOKEN_PIN)
            }

            this.$store.commit('setHasPin', false)
            if (this.prevRoutePath.includes('deeplink')) {
              this.$router.push(this.prevRoutePath).catch(() => { /* Do nothing */ })
              return
            }
            this.$router.push({ name: 'Home' }).catch(() => { /* Do nothing */ })
          } else {
            this.resetInput()
            this.dialog.message = res.data.data.message
            this.dialog.show = true
          }
        })
        .catch(() => {
          this.resetInput()
          this.dialog.message = 'Desila se greška. Pokušajte ponovo.'
          this.dialog.show = true
        })
    },
    resetInput (): void {
      for (let i = 0; i < this.numOfInputs; i++) {
        this.pinArray[i] = ''
      }

      const input1 = this.$refs[this.pinKey + '0'] as Array<HTMLInputElement>
      input1[0].focus()
    },
    logout () {
      this.$router.push({ name: 'Logout' })
    }
  }
})
